import { gql } from '@apollo/client';

export const EndParkingSessionMutation = gql`
  mutation ($id: ID!) {
    endParkingSession(id: $id) {
      id
      startedAt
      endedAt
      gate {
        id
      }
      parking {
        id
      }
      user {
        id
        email
      }
    }
  }
`;
